import { routeConstants } from 'app/routes/route-constants';

export const getBackRoute = () => routeConstants.externalUrlList;
